module.exports = require("./assets");


//////////////////
// WEBPACK FOOTER
// external "./assets"
// module id = 283
// module chunks = 0